(() => {
  document.querySelectorAll('[data-mc-product]').forEach(root => root.classList.add('mc-variants-enhanced'));
  const syncSticky = (root, option) => {
    const sticky = root.querySelector('[data-pdp-sticky]') || document.querySelector('[data-pdp-sticky]');
    if (!sticky || !option) return;
    const stickySelect = sticky.querySelector('[data-sticky-variant]');
    if (stickySelect) stickySelect.value = option.value;
    const price = sticky.querySelector('[data-sticky-price]');
    if (price) price.textContent = option.dataset.price || '';
    const add = sticky.querySelector('[data-sticky-add]');
    if (add) { add.disabled = option.dataset.available !== 'true'; add.textContent = add.disabled ? sticky.dataset.soldLabel || 'Épuisé' : sticky.dataset.addLabel || 'Ajouter au panier'; }
  };
  const updateImage = (root, src, alt = '', videoSrc = '') => {
    const image = root.querySelector('.mc-gallery__image');
    if (!image || !src) return;
    image.src = src;
    image.removeAttribute('srcset');
    image.alt = alt;
    const video = root.querySelector('.mc-gallery__video');
    if (video) {
      video.pause();
      video.hidden = !videoSrc;
      root.querySelector('.mc-gallery__main').hidden = Boolean(videoSrc);
      if (videoSrc) { video.src = videoSrc; video.poster = src; }
      else { video.removeAttribute('src'); video.load(); }
    }
    const caption = root.querySelector('[data-gallery-caption]');
    if (caption) caption.hidden = src !== root.querySelector('[data-gallery-image]')?.dataset.galleryImage;
    const enlarged = root.querySelector('.mc-gallery__dialog img');
    if (enlarged) { enlarged.src = src; enlarged.alt = alt; }
    root.querySelectorAll('[data-gallery-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryImage === src)));
  };
  document.addEventListener('click', event => {
    const favorite = event.target.closest('[data-product-favorite]');
    if (favorite) {
      const saved = favorite.getAttribute('aria-pressed') !== 'true';
      document.querySelectorAll('[data-product-favorite]').forEach(button => {
        if (button.dataset.productFavorite !== favorite.dataset.productFavorite) return;
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', saved ? 'Retirer des favoris' : 'Ajouter aux favoris');
      });
      try { localStorage.setItem('mc-favorite-' + favorite.dataset.productFavorite, String(saved)); } catch {}
    }
    const productStory = event.target.closest('[data-product-story]');
    if (productStory) {
      const dialog = productStory.closest('[data-mc-product]').querySelector(`[data-story-dialog="${productStory.dataset.productStory}"]`);
      dialog?.showModal();
    }
    const introToggle = event.target.closest('[data-intro-toggle]');
    if (introToggle) {
      const expanded = introToggle.getAttribute('aria-expanded') !== 'true';
      introToggle.setAttribute('aria-expanded', String(expanded));
      introToggle.textContent = expanded ? 'VOIR MOINS' : 'VOIR PLUS';
      introToggle.parentElement.querySelector('[data-intro-content]').classList.toggle('is-expanded', expanded);
    }
    const colorsToggle = event.target.closest('[data-colors-toggle]');
    if (colorsToggle) {
      const expanded = colorsToggle.getAttribute('aria-expanded') !== 'true';
      colorsToggle.setAttribute('aria-expanded', String(expanded));
      colorsToggle.textContent = expanded ? 'Voir moins de couleurs' : 'Voir plus de couleurs';
      colorsToggle.parentElement.querySelector('.mc-pdp__swatches').classList.toggle('is-expanded', expanded);
    }
    const thumbnail = event.target.closest('[data-gallery-image]');
    if (thumbnail) {
      const root = thumbnail.closest('[data-mc-product]');
      updateImage(root, thumbnail.dataset.galleryImage, thumbnail.dataset.imageAlt, thumbnail.dataset.galleryVideo);
      thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      const track = root.querySelector('.mc-gallery__mobile-track');
      if (track && matchMedia('(max-width: 749px)').matches) {
        const index = [...root.querySelectorAll('[data-gallery-image]')].indexOf(thumbnail);
        const card = track.children[index];
        if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
    const mobileImage = event.target.closest('[data-mobile-gallery-image]');
    if (mobileImage) updateImage(mobileImage.closest('[data-mc-product]'), mobileImage.dataset.mobileGalleryImage, mobileImage.dataset.imageAlt);
    const nextImage = event.target.closest('[data-gallery-next]');
    if (nextImage) {
      const items = [...nextImage.closest('[data-mc-product]').querySelectorAll('[data-gallery-image]')];
      const active = items.findIndex(item => item.getAttribute('aria-pressed') === 'true');
      const next = items[(active + 1) % items.length];
      next?.click();
      next?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    const open = event.target.closest('[data-gallery-open]');
    if (open) open.closest('[data-mc-product]').querySelector('dialog')?.showModal();
    const close = event.target.closest('[data-gallery-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.mc-gallery__dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-radio]')) {
      const select = event.target.closest('[data-mc-product]').querySelector('[data-variant-select]');
      select.value = event.target.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (event.target.matches('[data-sticky-variant]')) {
      const root = event.target.closest('[data-mc-product]') || document.querySelector('[data-mc-product]');
      const select = root.querySelector('[data-variant-select]');
      select.value = event.target.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (event.target.matches('[data-collection-sort]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url);
    }
    if (!event.target.matches('[data-variant-select]')) return;
    const root = event.target.closest('[data-mc-product]');
    const option = event.target.selectedOptions[0];
    root.querySelectorAll('[data-variant-radio]').forEach(radio => { radio.checked = radio.value === option.value; });
    const add = root.querySelector('[data-add-button]');
    const compare = root.querySelector('[data-variant-compare]');
    root.querySelector('[data-variant-price]').textContent = option.dataset.price;
    compare.textContent = option.dataset.compare;
    compare.hidden = !option.dataset.compare;
    add.disabled = option.dataset.available !== 'true';
    add.textContent = add.disabled ? add.dataset.soldLabel : add.dataset.addLabel;
    const quantity = root.querySelector('[data-quantity]');
    quantity.min = option.dataset.quantityMin || '1';
    quantity.step = option.dataset.quantityStep || '1';
    if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    if (option.dataset.image) updateImage(root, option.dataset.image, option.dataset.imageAlt);
    syncSticky(root, option);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-product-question-form]')) return;
    event.preventDefault();
    const root = event.target.closest('[data-mc-product]');
    const question = event.target.querySelector('[data-product-question]').value.trim().toLowerCase();
    const words = question.match(/[a-z]{3,}/g) || [];
    const faq = JSON.parse(root.querySelector('[data-product-faq-data]').textContent);
    const ranked = faq.map(item => ({...item, score:words.filter(word => (item.q + ' ' + item.a).toLowerCase().includes(word)).length})).sort((a,b) => b.score-a.score);
    const result = root.querySelector('[data-product-answer]');
    result.hidden = false;
    result.textContent = ranked[0]?.score ? ranked[0].a : 'Consultez les questions fréquentes ci-dessous ou contactez notre équipe.';
  });
  document.addEventListener('close', event => {
    if (event.target.matches('.mc-product-story-dialog')) event.target.querySelectorAll('video').forEach(video => video.pause());
  }, true);
  document.addEventListener('click', event => {
    const stickyAdd = event.target.closest('[data-sticky-add]');
    if (!stickyAdd || stickyAdd.disabled) return;
    const root = stickyAdd.closest('[data-mc-product]') || document.querySelector('[data-mc-product]');
    root?.querySelector('[data-add-button]')?.click();
  });
  document.querySelectorAll('[data-product-favorite]').forEach(button => { try { button.setAttribute('aria-pressed', String(localStorage.getItem('mc-favorite-' + button.dataset.productFavorite) === 'true')); } catch {} });
  document.querySelectorAll('[data-mc-product]').forEach(root => {
    const select = root.querySelector('[data-variant-select]');
    const option = select?.selectedOptions?.[0];
    if (option) syncSticky(root, option);
    const sticky = root.querySelector('[data-pdp-sticky]') || document.querySelector('[data-pdp-sticky]');
    if (sticky) { sticky.dataset.addLabel = sticky.querySelector('[data-sticky-add]')?.textContent || 'Ajouter au panier'; sticky.dataset.soldLabel = 'Épuisé'; }
  });
})();
